import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock, faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from "@mui/material";
import { convertToHHMM, convertToDateWithHHMM } from "../../medias/utils.js";

const BoxMedia = ({media, children, match}) => {

    const {isPin} = media

    const theme = useTheme();

    // Fonction pour trouver les noms des tags correspondant à media.tags
    const getTagNames = () => {
      if(!media.tags || !media.tags.length)
        return []
      
      return media.tags
        .map(tagId => match.tags.find(tag => tag._id === tagId)) // Trouver le tag correspondant
        .filter(tag => tag) // Filtrer les tags qui existent
        .map(tag => '#'+tag.name); // Récupérer le nom du tag
    };

    const tagNames = getTagNames(); // Récupérer les noms des tags à afficher

    return  <Box
              sx={{
                position : 'relative',
                padding: '16px',
                ...(isPin && {
                  borderRadius : '20px',
                  backgroundColor: `${theme.palette.pinBox.mainBackground}`,
                  margin: '0 20px',
                  marginBottom : '30px'
                })
              }}
            >
              {isPin && 
              <Box sx={{
                position : 'absolute', 
                top : '-15px', 
                right : '-15px',
                width: "40px",
                height : "40px",
                borderRadius: 40,
                border : `4px solid ${theme.palette.pinBox.mainBackground}`,
                background: `${theme.palette.media.lightgrey}`,
                transform: 'rotate(30deg)',

                display : 'flex',
                alignItems : 'center',
                justifyContent : 'center'
              }}>
                <FontAwesomeIcon icon={faThumbtack}  />
              </Box>
              
              }
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb : 0
                  }}
                >
                {!isPin && <React.Fragment>
                  <Box
                      sx={{
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <FontAwesomeIcon icon={faClock} />
                    </Box>
                    <Box
                      sx={{
                        padding: '8px',
                      }}
                    >
                      <Typography variant="h3" sx={{lineHeight : 1.5}}>{convertToDateWithHHMM(media.displayDate ?? media.creation)}</Typography>
                    </Box>
                </React.Fragment>}
                </Box>

                
                {children}
                {/* Affichage des tags */}
                <Box>
                  {tagNames.length > 0 && (
                    <Typography variant="subtitle2" sx={{ fontSize: '0.8em', color: theme.palette.text.secondary }}>
                      {tagNames.join(', ')}
                    </Typography>
                  )}
                </Box>
            </Box>
}

export default BoxMedia